import axios from "axios";
import React, { useEffect, useState, useContext, useRef } from "react";
import { Nav, Tab, Row, Col } from "react-bootstrap";
import ChooseTemplateCard from "../../Components/Template/ChooseTemplateCard";
import { ChooseTemplate, TemplateType } from "../../Models/ChooseTemplate";
import { apiConf, templateActionEnum } from "../../Config/Constants";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import { EnableHomeRenderFromBlob } from "../../Util/general-config";
import Select, { ActionMeta, SingleValue } from "react-select";

type Option = {
  value: string;
  label: string;
};

const Home = () => {
  const [chooseTemplateTypeList, setChooseTemplateTypeList] = useState(
    {} as TemplateType
  );
  const { dispatch } = useContext(TemplateDataContext);
  const [sortOption, setSortOption] = useState<Option | null>();
  const [searchQuery, setSearchQuery] = useState("");

   // Ensure homepage footer is visible and non-sticky
  useEffect(() => {
    document.body.classList.add("homepage-footer");
    return () => {
      document.body.classList.remove("homepage-footer");
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (EnableHomeRenderFromBlob() == false) {
          const response = await axios.get(`../../data/HomePage.json`);
          if (response.data) {
            setChooseTemplateTypeList(response.data);
          } else {
            throw response;
          }
        } else {
          // default file from blob..
          const response = await axios.get(
            `${apiConf.developmentBaseUrlForObject}/HomePage.json`
          );
          //  const response = await axios.get(`/data/HomePage.json`);
          if (response.data) {
            setChooseTemplateTypeList(response.data);
          } else {
            throw response;
          }
        }
      } catch (error) {
        console.error("🔥 ~ fetchHomeData ~ error", error);
      }
    })();
  }, []);

  useEffect(() => {
    dispatch({ type: templateActionEnum.LOAD_TEMPLATE, payload: [] });
  }, []);

  const sortTemplate = ["Popular Title", "A-Z", "Z-A"];
  const optionList: Option[] = sortTemplate.map((opt) => ({
    value: opt,
    label: opt,
  }));
  const sortTemplates = (
    sortingStrategy: (a: ChooseTemplate, b: ChooseTemplate) => number
  ) => {
    const sortedList = { ...chooseTemplateTypeList };
    Object.keys(sortedList).forEach((key) => {
      sortedList[key].sort(sortingStrategy);
    });
    setChooseTemplateTypeList(sortedList);
  };

  const sortByAlphabeticalTitle =
    (ascending = true) =>
    (a: { title: string }, b: { title: string }) => {
      return ascending
        ? a.title.localeCompare(b.title)
        : b.title.localeCompare(a.title);
    };

  const sortByPopularTitle =
    (ascending = true) =>
    (a: { rank: number }, b: { rank: number }) => {
      return ascending ? a.rank - b.rank : b.rank - a.rank;
    };

  const handleSortChange = (selectedOption: SingleValue<Option>) => {
    if (!selectedOption) {
      setSortOption(null);
      sortTemplates(sortByPopularTitle());
    } else {
      setSortOption(selectedOption);
      switch (selectedOption.value) {
        case "Popular Title":
          sortTemplates(sortByPopularTitle());
          break;
        case "A-Z":
          sortTemplates(sortByAlphabeticalTitle());
          break;
        case "Z-A":
          sortTemplates(sortByAlphabeticalTitle(false));
          break;
        default:
          break;
      }
    }
  };

  const searchPost = (query: string) => {
    setSearchQuery(query);
  };

  const filterTemplates = (templateList: TemplateType, query: string) => {
    const filteredTemplates: TemplateType = {};
    let hasSearchResults = false;

    Object.keys(templateList).forEach((key) => {
      filteredTemplates[key] = templateList[key].filter((template) =>
        template.title.toLowerCase().includes(query.toLowerCase())
      );
      if (filteredTemplates[key].length > 0) {
        hasSearchResults = true;
      }
    });

    return hasSearchResults ? filteredTemplates : null;
  };
  const clearSearch = () => {
    setSearchQuery("");
  };

  const filteredTemplateList = searchQuery
    ? filterTemplates(chooseTemplateTypeList, searchQuery)
    : chooseTemplateTypeList;

  return (
    <section className="body-section">
      <div className="container">
        {/* <div className="card-header headerheight">
                </div> */}
        <div className="title-wrap text-center">
          <h1 className="page-title">Choose The Template Type</h1>
        </div>
        <div style={{ justifyContent: "center" }} className="row mt-2 p-2">
          {Object.keys(chooseTemplateTypeList).length ? (
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={Object.keys(chooseTemplateTypeList)[0]}
            >
              <Row>
                <Col sm={12}>
                  <Nav
                    variant="pills"
                    className="d-flex justify-content-center"
                  >
                    <>
                      {Object.keys(chooseTemplateTypeList).map(
                        (templateKey, nvaLinkIndex) => (
                          <Nav.Item className="ms-3" key={nvaLinkIndex}>
                            <Nav.Link eventKey={templateKey} className="tabs">
                              {templateKey}
                            </Nav.Link>
                          </Nav.Item>
                        )
                      )}
                    </>
                  </Nav>
                  <div className="d-flex justify-content-between mt-4">
                    <div className="search-bar-rebrand input-group rounded w-100 border border-solid">
                      <input
                        className="form-control border-0"
                        placeholder="Search thousands of legal documents and forms"
                        style={{ minHeight: "38px" }}
                        value={searchQuery}
                        onChange={(e) => searchPost(e.target.value)}
                      />
                      {searchQuery && (
                        <button
                          className="btn  p-0 border-0"
                          type="button"
                          onClick={clearSearch}
                          style={{ backgroundColor: "#F9F9F9" }}
                        >
                          <i className="fa fa-times px-3 text-muted opacity-50" />
                        </button>
                      )}
                      <button className="btn bg-transparent p-0" type="button">
                        <i className="fa fa-search px-3 text-muted" />
                      </button>
                    </div>
                    {/* <div className=" col-sm-2">
                      <Select
                        className="sorting px-1 "
                        options={optionList}
                        isClearable
                        placeholder="Sort Template"
                        value={sortOption}
                        onChange={handleSortChange}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 4,
                          colors: {
                            ...theme.colors,
                            primary25: "primary50",
                            primary: "#C0C0C0",
                          },
                        })}
                      />
                    </div> */}
                  </div>
                </Col>
                  <Col sm={12} className="mt-5">
                  <Tab.Content>
                    {filteredTemplateList ? (
                      Object.keys(filteredTemplateList).map(
                        (templateKey, nvaLinkIndex) => (
                          <Tab.Pane eventKey={templateKey} key={nvaLinkIndex}>
                            <div className="grid-layout-new">
                              {filteredTemplateList[templateKey].map((template, index) => (
                                <div key={index}>
                                  <ChooseTemplateCard {...template} />
                                </div>
                              ))}
                            </div>
                          </Tab.Pane>
                        )
                      )
                    ) : (
                      <div className="text-center">No results found</div>
                    )}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          ) : (
            <></>
          )}
        </div>
      </div>
    </section>
  );
};

export default Home;
